import React from 'react';
import i18n from 'i18next';
import { IconWithText } from 'Components';

const ExportToExcel = props => (
  <IconWithText
    text={i18n.t('common:Export to Excel')}
    textOrientation="after"
    icon="publish"
    rotate={180}
    {...props}
  />
);

export default ExportToExcel;



// WEBPACK FOOTER //
// ./src/components/Actions/ExportToExcel/ExportToExcel.jsx